import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../TableTemplate/tableTemplate";
import { IDetailProcessReport } from "../../../Interfaces/deltaHedgeExe";
import { useState } from "react";
import Button from "../../../Components/Button";
import Modal from "../../../Components/Modal/Modal";
import SahraOrdersTable from "./SahraOrderTable";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell />
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IDetailProcessReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableCell>
        {open ? (
          <Modal title="جزئیات"
            UI={
              <SahraOrdersTable
                searchParams={{ processId: row.processId } as any}
              />
            }
            onClose={() => setOpen(false)}
          />
        ) : (
          <></>
        )}
        <div className="w-16">
          <Button
            text="جزییات"
            variant="contained"
            className="table-btn"
            onClick={() => setOpen(true)}
          />
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<IDetailProcessReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
